import React, {useContext, useEffect} from 'react'
import headbandContext from 'contexts/headband'
import Trombinoscope from 'components/trombinoscope/trombinoscope'
import "./trombiDrhf.scss"
import personnes from 'constants/personnes'
export default function TrombiDrhf() {
    const {setHeadband} = useContext(headbandContext)
    useEffect(() => {
        setHeadband({
            title :  "trombinoscope de l'équipe",
            icon : "picto_trombinoscope.svg",
            color : "bckGreen"
        })
    }, [])
    return (
        <div id="trombiDrhf" className='page'>
            <Trombinoscope personnes={personnes} />
        </div>
    )
}
